import React from 'react'
import { useState } from 'react';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { Tooltip } from '@mui/material';
import AgreeEconomistBillItemAllForm from './AgreeEconomistBillItemForm';
import MyModal from '../../../../../../../../UI/modal/MyModal';

const AgreeEconomistAllButton = ({ supplyBillId, supplyBillItems }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        {/* <SupplyBillAgreeIco
            onClick={e => setOpen(true)}
            text={'Погодження економістом'}
            ico={<MonetizationOnIcon />}
            value={supplyBillItem.isAgreeEconomist}
        /> */}
        <Tooltip
            title={'Погодження економістом'}
            onClick={e => setOpen(true)}
        >
            <MonetizationOnIcon />
        </Tooltip>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Погодження'}
            disableClickOutside={true}
            content={
                <AgreeEconomistBillItemAllForm
                    supplyBillId={supplyBillId}
                    supplyBillItems={supplyBillItems}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default AgreeEconomistAllButton